import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { AssetHierarchyComponent } from "../../shared/widgets/asset-hierarchy/asset-hierarchy.component";
import { ASSET_TYPES } from "../../enums/assetTypes.enum";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { pathToAssetType } from "../../shared/utils/assetType.utils";
import { filter, startWith, map } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  standalone: true,
  selector: "app-status",
  imports: [AssetHierarchyComponent, RouterOutlet],
  templateUrl: "./status.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./status.component.scss",
})
export class StatusComponent {
  private router = inject(Router);
  public initialSelectedAssetId: string | null = null;
  public initialSelectedAssetType: string | null = null;
  private route = inject(ActivatedRoute);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        map(() => this.route.firstChild?.snapshot),
        takeUntilDestroyed()
      )
      .subscribe((snapshot) => {
        const path = snapshot?.routeConfig?.path?.split("/")[0] ?? null;
        this.initialSelectedAssetType = path ? pathToAssetType(path) : null;
        this.initialSelectedAssetId = snapshot?.paramMap.get("id") ?? null;
      });
  }

  /**
   * Navigate to the status page of the selected asset.
   * @param event Event containing the id and assetType of the asset to navigate to.
   */
  public selectAsset(event: { id: string; assetType: string }) {
    const assetType = event.assetType;
    let url: string;
    switch (assetType) {
      case ASSET_TYPES.TENANT:
        return;
      case ASSET_TYPES.CUSTOMER:
        url = "dashboard/status/customer";
        break;
      case ASSET_TYPES.LOCATION:
        url = "dashboard/status/location";
        break;
      case ASSET_TYPES.BUILDING:
        url = "dashboard/status/building";
        break;
      case ASSET_TYPES.GATE_SYSTEM:
        url = "dashboard/status/gateSystem";
        break;
      default:
        url = "dashboard/status/customer";
        break;
    }

    this.router.navigate([url, event.id]);
  }
}
